import { prettyPrintJson } from "./prettyPrintJson";

export function checkExhausted(value: never): never {
  throw new Error(`Exhaustive switch failed: ${prettyPrintJson(value)}`);
}
